export default
{
    computed:
    {
        showRanges()
        {
            return this.ranges !== false && !this.readonly
        },

        showCalendars()
        {
            return this.alwaysShowCalendars || this.showCustomRangeCalendars
        },

        startText()
        {
            return this.start === null ? '' : this.$dateUtil.format( this.start, this.locale.format )
        },

        endText()
        {
            return this.end === null ? '' : this.$dateUtil.format( this.end, this.locale.format )
        },

        rangeText()
        {
            let range = this.startText;

            if( !this.singleDatePicker || this.singleDatePicker === 'range' )
            {
                range += this.locale.separator + this.endText;
            }

            return range;
        },

        min()
        {
            return this.minDate ? new Date( this.minDate ) : null
        },

        max()
        {
            return this.maxDate ? new Date( this.maxDate ) : null
        },

        isClear()
        {
            if( !this.singleDatePicker || this.singleDatePicker === 'range' )
            {
                return !this.modelValue.startDate || !this.modelValue.endDate;
            }
            else
            {
                return !this.modelValue.startDate;
            }
        },

        isDirty()
        {
            let origStart = new Date( this.modelValue.startDate );
            let origEnd   = new Date( this.modelValue.endDate );

            return !this.isClear && ( this.start.getTime() !== origStart.getTime() || this.end.getTime() !== origEnd.getTime() )
        },

        pickerStyles()
        {
            return (
            {

            })
        },

        scope()
        {
            return (
            {
                datepicker:
                {
                    attributes:
                    {
                        class:
                        {
                            "inline"     : this.opens === 'inline',
                            "active"     : this.open,
                            [this.class] : this.class
                        }
                    },

                    toggle:
                    {
                        attributes:
                        {
                            "ref" : 'toggle',
                        },

                        listeners:
                        {
                            "click" : this.onClickPicker
                        },

                        input:
                        {
                            attributes:
                            {
                                "ref"         : 'input',
                                "type"        : 'text',
                                "value"       : this.rangeText,
                                "placeholder" : this.placeholder,
                                "startDate"   : this.start,
                                "endDate"     : this.end,
                                "ranges"      : this.ranges,
                                "readonly"    : true,
                            }
                        }
                    },

                    dropdown:
                    {
                        attributes:
                        {
                            ref   : 'dropdown',
                            class :
                            {
                                'show-calendar'         : this.open || this.opens === 'inline',
                                'show-ranges'           : this.showRanges,
                                'show-weeknumbers'      : this.showWeekNumbers,
                                'single'                : this.singleDatePicker,
                                ['opens' + this.opens]  : true,
                                'linked'                : this.linkedCalendars,
                                'hide-calendars'        : !this.showCalendars,
                                [this.dropdownClass]    : this.dropdownClass
                            }
                        },

                        header:
                        {
                            attributes:
                            {
                                "rangeText"    : this.rangeText,
                                "locale"       : this.locale,
                                "clickCancel"  : this.clickCancel,
                                "clickApply"   : this.clickedApply,
                                "inSelection"  : this.in_selection,
                                "autoApply"    : this.autoApply
                            }
                        },

                        calendars:
                        {
                            rangesSlot:
                            {
                                attributes:
                                {
                                    "startDate"   : this.start,
                                    "endDate"     : this.end,
                                    "ranges"      : this.ranges,
                                    "clickRange"  : this.clickRange
                                }
                            },

                            ranges:
                            {
                                attributes:
                                {
                                    "always-show-calendars" : this.alwaysShowCalendars,
                                    "locale-data"           : this.locale,
                                    "ranges"                : this.ranges,
                                    "selected"              : { startDate: this.start, endDate: this.end }
                                },

                                listeners:
                                {
                                    "clickRange"      : this.clickRange,
                                    "showCustomRange" : () => this.showCustomRangeCalendars = true
                                }
                            },

                            calendar:
                            {
                                attributes:
                                {
                                    "locale-data"       : this.locale,
                                    "start"             : this.start,
                                    "end"               : this.end,
                                    "minDate"           : this.min,
                                    "maxDate"           : this.max,
                                    "show-dropdowns"    : this.showDropdowns,
                                    "date-format"       : this.dateFormatFn,
                                    "showWeekNumbers"   : this.showWeekNumbers
                                },

                                listeners:
                                {
                                    "dateClick" : this.dateClick,
                                    "hoverDate" : this.hoverDate
                                }
                            },

                            calendarTime:
                            {
                                attributes:
                                {
                                    "miniute-increment" : this.timePickerIncrement,
                                    "hour24"            : this.timePicker24Hour,
                                    "second-picker"     : this.timePickerSeconds,
                                    "current-time"      : this.start,
                                    "readonly"          : this.readonly
                                }
                            }
                        },

                        footer:
                        {
                            attributes:
                            {
                                "rangeText"    : this.rangeText,
                                "locale"       : this.locale,
                                "clickCancel"  : this.clickCancel,
                                "clickApply"   : this.clickedApply,
                                "inSelection"  : this.in_selection,
                                "autoApply"    : this.autoApply
                            }
                        }
                    }
                }
            })
        }
    }
}